/**
 * Reads tempo and time-signature text from `{tempo:}` / `{time:}` directives
 * and `Tempo:` / `BPM:` / `Time:` metadata lines.
 */
import { normalizeSongTempo, normalizeSongTimeSignature } from '../songMeta.js';
/** "120", "120 bpm", "♩ = 96", "Moderato 104" → BPM; anything else → null */
export const parseTempoText = (text) => {
    const match = text.match(/\d+(?:\.\d+)?/);
    return match ? normalizeSongTempo(Number(match[0])) : null;
};
/** "4/4", "6 / 8", "3/4 (waltz)" → time signature; anything else → null */
export const parseTimeSignatureText = (text) => {
    const match = text.trim().match(/^(\d{1,2})\s*\/\s*(\d{1,2})\b/);
    return match ? normalizeSongTimeSignature({ numerator: Number(match[1]), denominator: Number(match[2]) }) : null;
};
